/**
 * @file SeoCardActions.tsx
 * @description Низ карточки «Сайт → SEO → Основное» (phase19.16, партия
 * Р3в, v0.19.64; SB145, SB58, SB125): «Сохранить» — сразу на сайт, без
 * публикации; «Отменить» — вернуть поля карточки к сохранённым. При отказе
 * стоп-листа — список ошибок и галочка владельца (тот же `PublishAcknowledgeRow`,
 * что в окне публикации): сохранить можно, только поставив её.
 * На 360 кнопки во всю ширину, высота 48 px.
 */

import { Button } from "../../ui/button";
import { StopListAck } from "./StopListAck";
import type { SeoCardForm } from "../../../hooks/site-seo/useSeoCardForm";
import type { ShopSeoFieldKey } from "../../../lib/api-site-seo";

interface Props<K extends ShopSeoFieldKey> {
  form: SeoCardForm<K>;
  /** Нет права настроек — только просмотр. */
  readOnly?: boolean;
  /** Почему сохранить нельзя (неразборчивый код) — кнопка неактивна, текст под ней. */
  blockedReason?: string | null;
}

export function SeoCardActions<K extends ShopSeoFieldKey>({ form, readOnly = false, blockedReason = null }: Props<K>) {
  if (readOnly) return null;
  const blocked = (form.checks.length > 0 && !form.ack) || !!blockedReason;
  return (
    <div className="flex flex-col gap-2">
      <StopListAck checks={form.checks} ack={form.ack} onAck={form.setAck} />
      {form.dirty ? (
        <div className="flex flex-wrap gap-2">
          <Button className="max-sm:flex-1" loading={form.saving} disabled={blocked} onClick={() => void form.save()}>
            Сохранить
          </Button>
          <Button variant="ghost" className="max-sm:flex-1" disabled={form.saving} onClick={form.reset}>
            Отменить
          </Button>
          {blockedReason ? <p className="type-caption w-full text-destructive">{blockedReason}</p> : null}
        </div>
      ) : null}
    </div>
  );
}
